import { render, staticRenderFns } from "./BldCatPick.vue?vue&type=template&id=83440024&scoped=true&"
import script from "./BldCatPick.vue?vue&type=script&lang=js&"
export * from "./BldCatPick.vue?vue&type=script&lang=js&"
import style0 from "./BldCatPick.vue?vue&type=style&index=0&id=83440024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83440024",
  null
  
)

export default component.exports